// Canonical analytics filter / structured-query ops — re-exported from
// @wayai/core. The CLI now bundles @wayai/core (tsup `noExternal`), so this is
// a real runtime import rather than a hand-kept copy pinned by a drift-guard.
export {
  NUMERIC_FILTER_OPS,
  TEXT_FILTER_OPS,
  CATEGORICAL_FILTER_OPS,
  VARIABLE_FILTER_OPS,
  STRUCTURED_QUERY_OPS,
  STRUCTURED_QUERY_AGGREGATIONS,
} from '@wayai/core/contracts';
